import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { Helmet } from "react-helmet";

import RendererPage from "./render-pages/RendererPage";
import { ROUTES, URL_VCD } from "./utils/consts";
import history from "./utils/history";
import { decryptCredentials } from "./utils/cifrate";
import { NewLayout } from "./components/organisms/NewLayout";
import { getProductOptions } from "./utils/product";

function canRedirectHome(pathname, history) {
  if (!pathname || window.location.search !== "") {
    return false;
  }
  if (window.location.search !== "" && history.action === "PUSH") {
    return true;
  }
  if (history.action === "POP") {
    return true;
  }
}

function App() {
  const locationPathname = window.location.pathname;
  const { homePath, pageTitle, pageDescription, appId, productName } = getProductOptions();
  const redirect = () => {
    if (canRedirectHome(locationPathname, history)) {
      return history.push(homePath);
    }
  };

  useEffect(() => {
    const checkout = document.createElement("script");
    checkout.type = "text/javascript";
    checkout.src = decryptCredentials(process.env.REACT_APP_URL_CHECKOUT);
    document.head.appendChild(checkout);
  }, []);

  return (
    <Switch>
      {<Redirect Key={"-"} exact path="/" to={`/comprar/${URL_VCD}`} />}
      <NewLayout>
        {ROUTES.map((route, key) => {
          return (
            <Route exact path={route} key={key}>
              <div className="App">
                <Helmet>
                  <title>{pageTitle}</title>
                  <meta name="description" content={pageDescription}></meta>
                  <link
                    rel="canonical"
                    href={`https://www.rimac.com/comprar/${productName}`}
                  />
                  <script
                    src="/ventadigital/devolucion/libs/instana.js"
                    data-key={appId}
                    data-product={productName}
                    defer
                  ></script>
                  <script
                    defer
                    crossorigin="anonymous"
                    src="https://eum.instana.io/eum.min.js"
                  ></script>
                </Helmet>
                {redirect()}
                {RendererPage(route)}
              </div>
            </Route>
          );
        })}
      </NewLayout>
    </Switch>
  );
}

export default App;
